import React from 'react';

import classNames from 'classnames';

import Button from '../../../Button';

import renderFormInputs from '../../../../helpers/renderFormInputs';

export default function FieldGroup({
  title,
  fields,
  formik,
  prevGroupsSize,
  isVisible,
  tabindex,
  isTitleHidden,
  gridStyle,
  readOnly,
  subTitle,
  headerRight,
  titleStyle,
  isSubmitting,
  disabled,
  submitButtonLabel,
  inlineSubmitButton,
  isLastOne,
  isArray,
  innerIndex,
  arrayFieldName,
  isDraggable,
  onDragStart,
  inlineRight,
  inlineLeft,
  isSettingsForm,
}) {
  return (
    <fieldset draggable={isDraggable && !readOnly} onDragStart={onDragStart}>
      <legend
        className={classNames(
          'text-2xl text-slate-800 dark:text-slate-100 font-bold flex justify-between w-full',
          titleStyle,
          {
            'mb-6': !isArray,
            'flex-col sm:flex-row gap-4': !!headerRight,
          }
        )}
      >
        {isTitleHidden ? '' : title} {headerRight}
      </legend>
      {subTitle && (
        <p className="text-slate-600 dark:text-slate-400 text-sm mb-6">
          {subTitle}
        </p>
      )}
      <div className="flex items-center gap-4">
        {inlineLeft}
        <div
          className={classNames(
            gridStyle || 'grid gap-5 md:grid-cols-3 xl:grid-cols-4 flex-grow',
            'flex-1'
          )}
        >
          {renderFormInputs({
            fields,
            formik,
            prevGroupsSize,
            isVisible,
            tabindex,
            readOnly,
            isArray,
            innerIndex,
            arrayFieldName,
            isSettingsForm,
          })}
          {inlineSubmitButton && isLastOne && (
            <Button
              disabled={disabled}
              type="submit"
              isSubmitting={isSubmitting}
              className="self-start mt-[1.65rem]"
            >
              {submitButtonLabel || 'Submit'}
            </Button>
          )}
        </div>
        {inlineRight}
      </div>
    </fieldset>
  );
}
